import React from "react";
import './static/tooltip.css';

const Tooltip = ({ children }) => {
    return (
        <div className="tooltip">
            {children}
        </div>
    );
};

export default Tooltip;